import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_right",
  "use": "icon-arrow_right-usage",
  "viewBox": "0 0 5 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 5 11\" id=\"icon-arrow_right\">\n    <path fill=\"currentColor\" d=\"M4.393 5.399L.835 9.986c-.142.185-.372.185-.514 0l-.215-.281c-.141-.186-.141-.487 0-.672l3.09-3.97L.11 1.092C-.032.906-.032.605.11.42L.324.14c.142-.186.372-.186.514 0l3.558 4.586c.14.186.14.487-.003.673z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol